import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Heart, Handshake, BarChart3 } from 'lucide-react';

const ecosystemItems = [
  {
    icon: Heart,
    title: 'Valoriser l\'engagement',
    description: 'Nous offrons aux entreprises et mécènes l\'opportunité de soutenir des projets à fort impact sociétal et environnemental, en cohérence avec leurs engagements RSE.',
  },
  {
    icon: Handshake,
    title: 'Créer du lien',
    description: 'Au-delà du simple financement, nous concevons des partenariats sur-mesure qui associent pleinement les mécènes au rayonnement des œuvres soutenues.',
  },
  {
    icon: BarChart3,
    title: 'Mesurer l\'impact',
    description: 'Nous mettons en place des dispositifs de suivi et de mesure d\'impact permettant aux mécènes de valoriser concrètement leur engagement auprès des publics ciblés.',
  },
];

export const EcosystemSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="py-24 md:py-32 bg-[#0a0a0c]" data-testid="ecosystem-section">
      <div className="container-custom">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="overline mb-4 block">Écosystème</span>
          <h2 className="text-3xl md:text-5xl font-medium mb-6">
            Donner du sens <span className="text-gradient">par l'image</span>
          </h2>
          <p className="text-[#a1a1aa] text-lg max-w-2xl mx-auto">
            Un écosystème vertueux qui connecte mécènes engagés et publics en quête de sens.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {ecosystemItems.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="glass p-8 rounded-2xl card-hover text-center"
              data-testid={`ecosystem-item-${index}`}
            >
              <div className="w-16 h-16 mx-auto rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] mb-6">
                <item.icon size={28} />
              </div>
              <h3 className="text-xl font-medium text-white mb-4">
                {item.title}
              </h3>
              <p className="text-[#a1a1aa] leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
